import Api from 'api'

const config = {
  baseURL: '/api/app/v1/',
}
const api = new Api(config)

api.fetchChart = ({ externalId, network, ...rest }) =>
  api.get(`${network}/statistics/accounts/${externalId}/dates`, { ...rest })
api.fetchAccountCampaigns = ({ externalId, network, ...rest }) =>
  api.get(`${network}/statistics/accounts/${externalId}/campaigns`, { ...rest })

export default api
